export default {
  data() {
    return {
      headlightExcludedProducts: [],
      headlightExclusionPendingId: null,
      headlightExclusionFailedId: null,
    }
  },

  computed: {
    canManageHeadlightExclusions() {
      return Boolean(
        this.$auth.loggedIn &&
          this.$auth.user?.role?.identifier === 'admin' &&
          this.headlightExclusionVehicleId &&
          this.headlightExclusionVersion
      )
    },
    headlightExclusionKey() {
      if (!this.canManageHeadlightExclusions) return null
      const { headlight_type_id, headlight_vehicle_detail_id } =
        this.headlightExclusionVersion
      return `${this.headlightExclusionVehicleId}-${headlight_type_id}-${headlight_vehicle_detail_id}`
    },
  },

  watch: {
    headlightExclusionKey() {
      this.fetchHeadlightExcludedProducts()
    },
  },

  mounted() {
    this.fetchHeadlightExcludedProducts()
  },

  methods: {
    async fetchHeadlightExcludedProducts() {
      this.headlightExcludedProducts = []
      this.headlightExclusionFailedId = null

      const key = this.headlightExclusionKey
      if (!key) return

      try {
        const { data } =
          await this.$vehicleService.fetchHeadlightExcludedProducts(
            this.headlightExclusionVehicleId,
            this.headlightExclusionVersion
          )
        if (key === this.headlightExclusionKey) {
          this.headlightExcludedProducts = data || []
        }
      } catch {
        this.headlightExcludedProducts = []
      }
    },

    async excludeFromHeadlightVersion(product) {
      if (this.headlightExclusionPendingId) return

      this.headlightExclusionPendingId = product.id
      this.headlightExclusionFailedId = null

      try {
        await this.$vehicleService.excludeHeadlightProduct(
          this.headlightExclusionVehicleId,
          { product_id: product.id, ...this.headlightExclusionVersion }
        )
        this.onHeadlightProductExcluded(product)
        this.headlightExcludedProducts = [
          ...this.headlightExcludedProducts.filter(
            excluded => excluded.id !== product.id
          ),
          product,
        ]
      } catch {
        this.headlightExclusionFailedId = product.id
      } finally {
        this.headlightExclusionPendingId = null
      }
    },

    async restoreToHeadlightVersion(product) {
      if (this.headlightExclusionPendingId) return

      this.headlightExclusionPendingId = product.id
      this.headlightExclusionFailedId = null

      try {
        await this.$vehicleService.restoreHeadlightProduct(
          this.headlightExclusionVehicleId,
          product.id,
          this.headlightExclusionVersion
        )
        this.headlightExcludedProducts = this.headlightExcludedProducts.filter(
          excluded => excluded.id !== product.id
        )
        this.onHeadlightProductRestored(product)
      } catch {
        this.headlightExclusionFailedId = product.id
      } finally {
        this.headlightExclusionPendingId = null
      }
    },
  },
}
